import React from "react";
import {Icon} from "@reside/ui";
import {ListTileViewSwitchWrapper} from "./styles";
import {
  LIST_VIEW_KEY,
  TILE_VIEW_KEY,
  VIEW_KEYS,
  ACTIVE_VIEW_CLASS,
} from "./utils/constants";

type ListTileViewSwitchProps = {
  view: (typeof VIEW_KEYS)[number];
  setView: (view: (typeof VIEW_KEYS)[number]) => void;
};

export const ListTileViewSwitch = ({
  view,
  setView,
}: ListTileViewSwitchProps) => {
  const handleViewChange = (view: (typeof VIEW_KEYS)[number]) => {
    setView(view);
  };

  return (
    <ListTileViewSwitchWrapper>
      <Icon
        name="th-large-outline"
        onClick={() => handleViewChange(TILE_VIEW_KEY)}
        className={view === TILE_VIEW_KEY ? ACTIVE_VIEW_CLASS : ""}
      />
      <Icon
        name="th-list"
        onClick={() => handleViewChange(LIST_VIEW_KEY)}
        className={view === LIST_VIEW_KEY ? ACTIVE_VIEW_CLASS : ""}
      />
    </ListTileViewSwitchWrapper>
  );
};
